<script setup lang="ts">
defineProps<{ title: string; count?: number; id?: string }>()
</script>

<template>
  <div class="flex items-center justify-between gap-3 mb-3">
    <h2 :id="id" class="text-base font-semibold text-(--csp-text)">
      {{ title }}<span v-if="count !== undefined" class="font-normal csp-muted ml-1.5">{{ count }}</span>
    </h2>
    <div class="flex items-center gap-4 text-[13px]"><slot /></div>
  </div>
</template>
